import n, { forwardRef as g } from "react";
import { ScreenReaderOnly as S } from "../utils/sr-only.esm.js";
const m = "_loadingSpinnerWrapper_181pd_3", c = "_loadingSpinner_181pd_3", y = "_loadingSpinner--xsmall_181pd_12", f = "_loadingSpinner--small_181pd_17", u = "_loadingSpinner--medium_181pd_22", v = "_loadingSpinner--large_181pd_27", $ = "_loadingSpinner--responsive_181pd_33", x = "_fadein_181pd_1", N = "_rotate_181pd_1", h = "_dash_181pd_1", E = "_loadingSpinner--primary_181pd_103", L = "_loadingSpinner--secondary_181pd_107", R = "_loadingSpinner--tertiary_181pd_111", i = {
  loadingSpinnerWrapper: m,
  loadingSpinner: c,
  "loadingSpinner--xsmall": "_loadingSpinner--xsmall_181pd_12",
  loadingSpinnerXsmall: y,
  "loadingSpinner--small": "_loadingSpinner--small_181pd_17",
  loadingSpinnerSmall: f,
  "loadingSpinner--medium": "_loadingSpinner--medium_181pd_22",
  loadingSpinnerMedium: u,
  "loadingSpinner--large": "_loadingSpinner--large_181pd_27",
  loadingSpinnerLarge: v,
  "loadingSpinner--responsive": "_loadingSpinner--responsive_181pd_33",
  loadingSpinnerResponsive: $,
  fadein: x,
  rotate: N,
  dash: h,
  "loadingSpinner--primary": "_loadingSpinner--primary_181pd_103",
  loadingSpinnerPrimary: E,
  "loadingSpinner--secondary": "_loadingSpinner--secondary_181pd_107",
  loadingSpinnerSecondary: L,
  "loadingSpinner--tertiary": "_loadingSpinner--tertiary_181pd_111",
  loadingSpinnerTertiary: R
}, W = g(
  ({
    dataTestId: e = "fuse-loading-spinner-data-test-id",
    size: r = "responsive",
    variant: a = "primary",
    animationTime: d = 0.5,
    className: p,
    ...o
  }, l) => {
    const s = `${i.loadingSpinnerWrapper} fuse-loading-spinner ${p || ""}`.trim(), _ = `${i.loadingSpinner} fuse-loading-spinner__spinner ${i[`loadingSpinner--${r}`]} ${i[`loadingSpinner--${a}`]}`.trim(), t = {
      "--animation-time": `${d}s`
    };
    return /* @__PURE__ */ n.createElement("div", { className: s, "data-testid": e, ref: l, ...o }, /* @__PURE__ */ n.createElement("div", { className: _, style: t, "aria-live": "polite", role: "status" }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 50 50", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("circle", { cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" })), /* @__PURE__ */ n.createElement(S, { className: "fuse-loading-spinner__screen-reader-only" }, "Loading")));
  }
);
W.displayName = "LoadingSpinner";
export {
  W as LoadingSpinner
};
